// extracted by mini-css-extract-plugin
export default {"externalLinks":"ExternalLinks_externalLinks__BHwnS"};